



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Customer } from './../entities/customer.entity';
import { BalanceView } from './../views/balance.view';
import { CredentialResult } from './../entities/credentialresult.entity';
@Injectable()
export class CustomerEndpoint extends BaseEndpointCRUD<Customer>
{
    constructor(api: APIGatewayService) {super("Customer", api);}
	

    public  GetCurrent() : Observable<BaseEntityResponse<Customer>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetCurrent',  undefined );
    }

    public  GetBalance(iCompanyID: number) : Observable<BaseEntityResponse<BalanceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetBalance',  {iCompanyID: iCompanyID} );
    }

    public  SaveBankDetails(oCustomer: Customer) : Observable<BaseEntityResponse<Customer>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'SaveBankDetails', oCustomer,  undefined );
    }

    public  List(options: DataLoadOptions) : Observable<BaseEntitiesResponse<Customer>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'List',  options?.GetLoadOptions() );
    }

    public  ChangeCreditCardRequest() : Observable<BaseResponse>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'ChangeCreditCardRequest',  undefined );
    }

    public  ConfirmChangeCreditCardRequest(sPrivateID: string) : Observable<BaseResponse>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'ConfirmChangeCreditCardRequest',  {sPrivateID: sPrivateID} );
    }

    public  GetBanksList() : Observable<BaseEntitiesResponse<GenericListEntity>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetBanksList',  undefined );
    }

    public  GetCredentials() : Observable<BaseEntitiesResponse<CredentialResult>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetCredentials',  undefined );
    }
    public HasOpenDocuments(): Observable<BaseDataResponse<boolean>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'HasOpenDocuments', { });
    }
    
}

